import { on } from "@ngrx/store";

import { InvoiceDetailsActions } from "../../invoices/invoice-details/invoice-details.component";
import { confirmSendInvoiceDialogAcceptButtonClicked } from "../../services/document-helper.service";
import { JobToolState } from "../job-tool.reducer";

import { JobInvoiceActions } from "./job-invoice.actions";

export const jobInvoiceReducers = [
  on(JobInvoiceActions.openInvoiceActionsMenuButtonClicked, (state: JobToolState, { invoiceId }): JobToolState => {
    return {
      ...state,
      actionsMenuInvoiceId: invoiceId,
    }
  }),
  on(
    confirmSendInvoiceDialogAcceptButtonClicked,
    JobInvoiceActions.sendInvoiceButtonClicked,
    InvoiceDetailsActions.sendInvoiceMenuItemClicked,
    (state: JobToolState, action): JobToolState => {

      if (action.type === InvoiceDetailsActions.sendInvoiceMenuItemClicked.type && !action.isFinalized) {
        // Not sending yet, need confirmation
        return state;
      }

      return {
        ...state,
        documentsSending: {
          ...state.documentsSending,
          [action.invoiceId]: true,
        },
      }
    },
  ),
  on(
    JobInvoiceActions.sendInvoiceSuccess,
    JobInvoiceActions.sendInvoiceError,
    (state: JobToolState, { invoiceId }): JobToolState => {

      const documentsSending = { ...state.documentsSending};

      delete documentsSending[invoiceId];

      return {
        ...state,
        documentsSending,
      }
    },
  ),
  on(
    JobInvoiceActions.updateInvoiceRequested,
    (state: JobToolState, action): JobToolState => {
      return {
        ...state,
        documentsUpdating: {
          ...state.documentsUpdating,
          [action.invoiceId]: true,
        },
      }
    },
  ),
  on(
    JobInvoiceActions.updateInvoiceSuccess,
    JobInvoiceActions.updateInvoiceError,
    JobInvoiceActions.updateInvoiceRefused,
    (state: JobToolState, { invoiceId }): JobToolState => {

      const documentsUpdating = { ...state.documentsUpdating};

      delete documentsUpdating[invoiceId];

      return {
        ...state,
        documentsUpdating,
      }
    },
  ),

];

